import React, { JSX, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material'
import ImageComponent from './ImageComponent'
import { NavLink, useLocation } from 'react-router-dom'
import { format } from 'date-fns'
import getDateFormat from './util/getDateFormat'
import { CoreConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

export interface SubmenuData {
  id: string
  label: string | JSX.Element
}

interface ISubmenuProps {
  data?: SubmenuData[]
  config?: CoreConfiguration
}

const useStyles = makeStyles((theme: Theme) => ({
  subMenuWrapper: {
    overflow: 'hidden',
    position: 'fixed',
    height: theme.spacing(6.25),
    width: '100%',
    padding: `0 ${theme.spacing(2.5)}`,
    bottom: 0,
    left: 0,
    right: 0,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    zIndex: 99,
    '& .MuiDivider-root': {
      borderColor: theme.palette.primary.contrastText,
    },
  },
  subMenu: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
    height: theme.spacing(6.25),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  subMenuText: {
    lineHeight: '25px',
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
}))

const Submenu: React.FC<ISubmenuProps> = React.memo((props) => {
  const classes = useStyles()
  const theme = useTheme()
  const location = useLocation()

  const [date, setDate] = useState(new Date())

  const refreshClock = () => {
    setDate(new Date())
  }

  useEffect(() => {
    const timerId = setInterval(refreshClock, 60000)
    return function cleanup () {
      clearInterval(timerId)
    }
  }, [])

  return (
    <Box className={classes.subMenuWrapper}>
      <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%' height={50}>
        <ImageComponent width={124} height={21} src={props.config?.footerLogo} fallback='/src/shared/assets/images/professocial_logo_header.png' />
        <Stack direction='row' divider={<Divider orientation='vertical' variant='middle' flexItem />}>
          {props.data && props.data.map((elem: SubmenuData, index: number) => {

            return (
              <NavLink
                to={`/${location.pathname.split('/').slice(1, 3).join('/')}/${elem.id}`}
                key={index}
                activeStyle={{
                  fontWeight: 600,
                  backgroundColor: theme.palette.action.hover,
                }}
                className={`${classes.subMenu}`}
              >
                <Typography
                  className={`${classes.subMenuText}`}
                  variant='subtitle1'
                >{elem.label}
                </Typography>
              </NavLink>
            )
          })}
        </Stack>
        <Typography variant='body1' color={theme.palette.primary.contrastText}>{format(date, getDateFormat('dateTime'))} | v3.0.0-SNAPSHOT</Typography>
      </Stack>
    </Box>
  )
})

Submenu.displayName = 'Submenu'

Submenu.propTypes = {
  data: PropTypes.array,
  config: PropTypes.object,
}

export default Submenu
